import { RESET_PG_VIEW, FETCH_PG_VIEW } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const pgModuleViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PG_VIEW:
      return { data: action.payload };
    case RESET_PG_VIEW:
      return initialState;
    default:
      return state;
  }
};

export default pgModuleViewReducer;
